export enum NavName {
  BACKGROUND_INFORMATION = 'Background information',
  CHANGE_PASSWORD = 'Change password',
  COMMUNICATION_PREFERENCES = 'Communication preferences',
  CONTACT_INFORMATION = 'Contact information',
  LOGIN_SECURITY = 'Login & Security',
  // TRUSTED_DEVICES = 'Manage trusted devices',
  PRIMARY_CARE_PROVIDER = 'Primary Care Provider (PCP)',
  TOBACCO_USE_STATUS = 'Tobacco use status',
}

export enum NavIds {
  BACKGROUND_INFORMATION = 'background-information',
  CHANGE_PASSWORD = 'change-password',
  COMMUNICATION_PREFERENCES = 'communication-preferences',
  CONTACT_INFORMATION = 'contact-information',
  LOGIN_SECURITY = 'multi-factor-authentication',
  // TRUSTED_DEVICES = 'trusted-devices',
  PRIMARY_CARE_PROVIDER = 'primary-care-provider',
  TOBACCO_USE_STATUS = 'tocacco-use-status',
}

type NavItem = {
  url:
    | string
    | {
        search: string;
        pathname: string;
        state: unknown;
        hash: string;
        key?: string | undefined;
      };
};

export interface SidebarLink extends NavItem {
  message_id: NavIds;
  name: NavName;
}

export const useSidebarLinksList = () => {
  const NavLinksList: SidebarLink[] = [
    {
      url: NavIds.BACKGROUND_INFORMATION,
      message_id: NavIds.BACKGROUND_INFORMATION,
      name: NavName.BACKGROUND_INFORMATION,
    },
    {
      url: NavIds.CHANGE_PASSWORD,
      message_id: NavIds.CHANGE_PASSWORD,
      name: NavName.CHANGE_PASSWORD,
    },
    {
      url: NavIds.COMMUNICATION_PREFERENCES,
      message_id: NavIds.COMMUNICATION_PREFERENCES,
      name: NavName.COMMUNICATION_PREFERENCES,
    },
    {
      url: NavIds.CONTACT_INFORMATION,
      message_id: NavIds.CONTACT_INFORMATION,
      name: NavName.CONTACT_INFORMATION,
    },
    {
      url: NavIds.LOGIN_SECURITY,
      message_id: NavIds.LOGIN_SECURITY,
      name: NavName.LOGIN_SECURITY,
    },
    // {
    //   url: NavIds.TRUSTED_DEVICES,
    //   message_id: NavIds.TRUSTED_DEVICES,
    //   name: NavName.TRUSTED_DEVICES,
    // },
    {
      url: NavIds.PRIMARY_CARE_PROVIDER,
      message_id: NavIds.PRIMARY_CARE_PROVIDER,
      name: NavName.PRIMARY_CARE_PROVIDER,
    },
    // {
    //   url: NavIds.TOBACCO_USE_STATUS,
    //   message_id: NavIds.TOBACCO_USE_STATUS,
    //   name: NavName.TOBACCO_USE_STATUS,
    // },
  ];

  return {
    navLinks: NavLinksList,
  };
};
